import { render, staticRenderFns } from "./StorageLocationChangeLogsDetailsView.vue?vue&type=template&id=a9d72ee8&scoped=true"
import script from "./StorageLocationChangeLogsDetailsView.vue?vue&type=script&lang=js"
export * from "./StorageLocationChangeLogsDetailsView.vue?vue&type=script&lang=js"
import style0 from "./StorageLocationChangeLogsDetailsView.vue?vue&type=style&index=0&id=a9d72ee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d72ee8",
  null
  
)

export default component.exports